import {
    EDIT_CURRENCY_FAILED,
    EDIT_CURRENCY_LOADING,
    EDIT_CURRENCY_SUCCESS,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const editCurrencyReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case EDIT_CURRENCY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status: null,
        };
      case EDIT_CURRENCY_SUCCESS:
        return {
          ...state,
          loading: false,
          status: action.payload,
        };
      case EDIT_CURRENCY_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status: null,
        };
    
      default:
        return state;
    }
  };
  